import { render, staticRenderFns } from "./FlexTablePro.vue?vue&type=template&id=bdf6b574&scoped=true"
import script from "./FlexTablePro.vue?vue&type=script&lang=js"
export * from "./FlexTablePro.vue?vue&type=script&lang=js"
import style0 from "./FlexTablePro.vue?vue&type=style&index=0&id=bdf6b574&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf6b574",
  null
  
)

export default component.exports